import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { change } from 'redux-form';
import { callAPI } from './apiActions';
import { showSnack } from './snackbarActions';
import { marginAccountSelector, defaultAccountSelector } from '../selectors/marginSelectors';
import AccountEventsSubscriptionService from '../../services/subscriptions/AccountEventsSubscriptionService';
import marginAccountStateSubscriptionService from '../../services/subscriptions/marginAccountStateSubscriptionService';
import marginAccountPositionEventSubscriptionService from '../../services/subscriptions/marginAccountPositionEventSubscriptionService';
import { getUserInfo, selectAccount } from './userActions';
import { getOpenPositions, getClosedPositions, getMarginPositionPayments, subscribeToMarginPositionStates, subscribeToMarginPositionPayments } from './marginHistoryActions';
import { subscribeToMarginAccountProducts, getMarginProducts } from './marginProductActions';
import * as TradingStyle from '../../constants/tradingStyleConstants';
import { getOpenOrders, getAccountTrades, getOpenTradeReports, subscribeToOrderHistory } from './orderHistoryActions';
import { getTransfers, getIncomingTransfers } from './transferActions';
import { getTransferRequestsReceived, getTransferRequestsRequested } from './transferRequestActions';
import { subscribeToMarketTradeUpdated } from './marketStateUpdateActions';
export var REQUEST_MARGIN_ACCOUNT_STATE = 'REQUEST_MARGIN_ACCOUNT_STATE';
export var RECEIVE_MARGIN_ACCOUNT_STATE = 'RECEIVE_MARGIN_ACCOUNT_STATE';
export var RECEIVE_MARGIN_STATUS = 'RECEIVE_MARGIN_STATUS';
var subscribeAccountEvents = function subscribeAccountEvents(AccountId, OMSId) {
  return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            AccountEventsSubscriptionService.initSubscription({
              AccountId: AccountId,
              OMSId: OMSId
            });
          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));
};
export var enableMargin = function enableMargin() {
  return function (dispatch, getState) {
    var state = getState();
    var OMSId = 1;
    var marginAccount = marginAccountSelector(state);
    if (marginAccount) {
      localStorage.setItem('tradingStyle', 'Margin');
      var AccountId = marginAccount.AccountId;
      dispatch(getMarginSettings(OMSId));
      dispatch(getMarginAccountState());
      dispatch(getMarginProducts(AccountId, OMSId));
      dispatch(getMarginInstruments(OMSId));
      dispatch(getOpenPositions(AccountId, OMSId));
      dispatch(getClosedPositions(AccountId, OMSId));
      dispatch(getMarginPositionPayments(AccountId, OMSId));

      // Below is duplicated from userActions.selectAccount.
      // However, it does not update state.user.selectedAccountId.
      // So it does not break wallets page.
      dispatch(getOpenOrders(AccountId, OMSId));
      dispatch(getAccountTrades(AccountId, OMSId));
      dispatch(getOpenTradeReports(AccountId, OMSId));
      dispatch(subscribeAccountEvents(AccountId, OMSId));
      dispatch(subscribeToOrderHistory());
      dispatch(subscribeToMarginPositionStates(AccountId, OMSId));
      dispatch(subscribeToMarginAccountProducts(AccountId, OMSId));
      dispatch(subscribeToMarginAccountState());
      dispatch(subscribeToMarginPositionPayments());
      dispatch(subscribeToMarketTradeUpdated());
      dispatch(subscribeToMarginAccountPositionEvents(AccountId));
      dispatch(getTransfers(AccountId));
      dispatch(getIncomingTransfers(OMSId, AccountId));
      dispatch(getTransferRequestsReceived(AccountId, OMSId));
      dispatch(getTransferRequestsRequested(AccountId, OMSId));
    }
  };
};
export var disableMargin = function disableMargin() {
  return function (dispatch, getState) {
    localStorage.setItem('tradingStyle', null);
    var state = getState();
    var OMSId = 1;
    var defaultAccountId = defaultAccountSelector(state).AccountId;
    dispatch(selectAccount(defaultAccountId, OMSId));
  };
};
export var getMarginInstruments = function getMarginInstruments(OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var selectedInstrumentId, instruments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
              _context2.prev = 1;
              dispatch(requestMarginInstruments());
              _context2.next = 5;
              return dispatch(callAPI('GetMarginEnabledInstruments', {
                OMSId: OMSId
              }));
            case 5:
              instruments = _context2.sent;
              dispatch(receiveMarginInstruments({
                instruments: instruments,
                selectedInstrumentId: selectedInstrumentId
              }));
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](1);
              console.error('GetMarginInstruments error: ', _context2.t0);
            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[1, 9]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var createMarginRequest = function createMarginRequest() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var OMSId, responseObj;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              OMSId = 1;
              _context3.prev = 1;
              _context3.next = 4;
              return dispatch(callAPI('CreateMarginBorrowerAccountRequest', {
                OMSId: OMSId
              }));
            case 4:
              responseObj = _context3.sent;
              if (!responseObj.result) {
                _context3.next = 10;
                break;
              }
              dispatch(showSnack({
                id: 'createMarginRequestSuccess',
                text: responseObj.detail || 'Successful Margin Account Request',
                type: 'success'
              }));
              return _context3.abrupt('return', true);
            case 10:
              dispatch(showSnack({
                id: 'createMarginRequestError',
                text: responseObj.detail,
                type: 'warning'
              }));
              return _context3.abrupt('return', false);
            case 12:
              _context3.next = 19;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](1);
              console.error('createMarginBorrowerAccountRequest error: ', _context3.t0);
              dispatch(showSnack({
                id: 'createMarginRequestError',
                text: _context3.t0.o,
                type: 'warning'
              }));
              return _context3.abrupt('return', false);
            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[1, 14]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var disableMarginRequest = function disableMarginRequest() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var OMSId, UserId, responseObj;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              OMSId = 1;
              UserId = getState().user.userInfo.UserId;
              _context4.prev = 2;
              _context4.next = 5;
              return dispatch(callAPI('SetUserMarginDisabled', {
                OMSId: OMSId
              }));
            case 5:
              responseObj = _context4.sent;
              if (responseObj.result) {
                dispatch(showSnack({
                  id: 'disableMarginRequestSuccess',
                  text: responseObj.detail || 'Margin disabled successfully',
                  type: 'success'
                }));
                dispatch(getUserInfo(UserId));
              } else {
                dispatch(showSnack({
                  id: 'disableMarginRequestError',
                  text: responseObj.detail,
                  type: 'warning'
                }));
              }
              _context4.next = 13;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4['catch'](2);
              console.error('disableMarginRequest error: ', _context4.t0);
              dispatch(showSnack({
                id: 'disableMarginRequestError',
                text: _context4.t0.o,
                type: 'warning'
              }));
            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[2, 9]]);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var getMarginAccountState = function getMarginAccountState() {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var OMSId, state, marginAccount, responseObj;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              OMSId = 1;
              state = getState();
              marginAccount = marginAccountSelector(state);
              if (marginAccount) {
                _context5.next = 7;
                break;
              }
              console.error('There is no margin account');
              _context5.next = 18;
              break;
            case 7:
              _context5.prev = 7;
              dispatch(requestMarginAccountState);
              _context5.next = 11;
              return dispatch(callAPI('GetMarginAccountState', {
                OMSId: OMSId,
                AccountId: marginAccount.AccountId
              }));
            case 11:
              responseObj = _context5.sent;
              dispatch(receiveMarginAccountState(responseObj));
              _context5.next = 18;
              break;
            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5['catch'](7);
              console.error('getMarginAccountState error: ', _context5.t0);
            case 18:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[7, 15]]);
    }));
    return function (_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var getMarginStatus = function getMarginStatus() {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var OMSId, UserId, responseObj;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              OMSId = 1;
              UserId = getState().user.userInfo.UserId;
              _context6.prev = 2;
              _context6.next = 5;
              return dispatch(callAPI('GetMarginBorrowerAccountRequest', {
                OMSId: OMSId,
                UserId: UserId
              }));
            case 5:
              responseObj = _context6.sent;
              dispatch(receiveMarginStatus(responseObj.Status));
              _context6.next = 12;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6['catch'](2);
              console.error('getMarginStatus error: ', _context6.t0);
            case 12:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[2, 9]]);
    }));
    return function (_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var RECEIVE_MARGIN_ACCT_POSITION = 'RECEIVE_MARGIN_ACCT_POSITION';
export var receiveMarginAccountPositionEvent = function receiveMarginAccountPositionEvent(payload) {
  return {
    type: RECEIVE_MARGIN_ACCT_POSITION,
    payload: payload
  };
};
export var subscribeToMarginAccountPositionEvents = function subscribeToMarginAccountPositionEvents(marginAccountId) {
  return function (dispatch) {
    marginAccountPositionEventSubscriptionService.subscribe(function (updates) {
      if (updates.AccountId === marginAccountId) dispatch(receiveMarginAccountPositionEvent(updates));
    });
  };
};
export var subscribeToMarginAccountState = function subscribeToMarginAccountState() {
  return function (dispatch) {
    marginAccountStateSubscriptionService.subscribe(function (updates) {
      dispatch(receiveMarginAccountState(updates));
    });
  };
};
export var requestMarginAccountState = {
  type: REQUEST_MARGIN_ACCOUNT_STATE
};
export var receiveMarginAccountState = function receiveMarginAccountState(payload) {
  return {
    type: RECEIVE_MARGIN_ACCOUNT_STATE,
    payload: payload
  };
};
export var REQUEST_MARGIN_INSTRUMENTS = 'REQUEST_MARGIN_INSTRUMENTS';
export var requestMarginInstruments = function requestMarginInstruments() {
  return {
    type: REQUEST_MARGIN_INSTRUMENTS
  };
};
export var RECEIVE_MARGIN_INSTRUMENTS = 'RECEIVE_MARGIN_INSTRUMENTS';
export var receiveMarginInstruments = function receiveMarginInstruments(instruments) {
  return {
    type: RECEIVE_MARGIN_INSTRUMENTS,
    payload: instruments
  };
};
export var SET_MARGIN_INSTRUMENT = 'SET_MARGIN_INSTRUMENT';
export var setMarginInstrument = function setMarginInstrument(instrumentId) {
  return {
    type: SET_MARGIN_INSTRUMENT,
    payload: instrumentId
  };
};
export var receiveMarginStatus = function receiveMarginStatus(marginStatus) {
  return {
    type: RECEIVE_MARGIN_STATUS,
    payload: marginStatus
  };
};
export var activateMarginTradingStyle = function activateMarginTradingStyle() {
  return function (dispatch) {
    dispatch(change('tradingStyle', 'tradingStyle', TradingStyle.marginTrade));
  };
};
export var deactivateMarginTradingStyle = function deactivateMarginTradingStyle() {
  return function (dispatch) {
    dispatch(change('tradingStyle', 'tradingStyle', TradingStyle.standardTrade));
  };
};
export var RECEIVE_MARGIN_SETTINGS = 'RECEIVE_MARGIN_SETTINGS';
export var receiveMarginSettings = function receiveMarginSettings(payload) {
  return {
    type: RECEIVE_MARGIN_SETTINGS,
    payload: payload
  };
};
export var getMarginSettings = function getMarginSettings(OMSId) {
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch(callAPI('GetMarginPublicSettings', {
                OMSId: OMSId
              })).then(function (data) {
                dispatch(receiveMarginSettings(data));
              });
            case 1:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));
    return function (_x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};